const css = `.RyowBq__clickable{cursor:pointer}.RyowBq__buttonContainer{opacity:.65}.RyowBq__buttonContainer:hover{opacity:1}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"buttonContainer":"RyowBq__buttonContainer","clickable":"RyowBq__clickable"};
